import lfConfig from '../config';

const getFromCdn = (src: string) => `${lfConfig.cdnUrl}static/${src}`;

export default getFromCdn;
